import React from 'react'
import "../articles.css"
import bulbs from "../../../../assets/images/articles/bulbs.jpg"
import { Byline, Published } from "../../"
import BP from "../../../../assets/images/articles/BalancingPrices.jpeg"
import BPmonth from "../../../../assets/images/articles/BPmonth.jpeg"

export default function Article10Doc() {
  return (
    <div className='emas__articles'>
    <div className='emas__articles-container'>
        <img className="emas__articles-container_headImage" src={bulbs} alt="bulbs"/>
        <div className='emas__articles-container_photo'>
          <i >Photo by Pixabay: https://www.pexels.com/photo/ball-bright-close-up-clouds-207489/</i>
        </div>
        <h1>Balancing Prices</h1>
        <div className='emas__articles-container_publish'>
          <p></p>
        </div>
        <div className='emas__articles-container_body'>
            <p>December 2023</p>
            <p>Balancing prices have become more volatile since the new market commenced in October 2023. The following chart shows daily balancing prices since January 2023. We are continuing to unpack how the new market is operating, but it appears that the volatility is the result of bidding behaviour, and particularly a greater proportion of generation being offered in at the cap.</p>
         </div>   
          <div className='emas__articles-container_photo'>
          <img className="emas__articles-container_headImage" src={BP} alt="BP"></img>
        </div>
          <div className='emas__articles-container_body'>
            <p>On average each month, however, prices were higher in June 2023, as the following chart shows.</p>
          </div>
          <div className='emas__articles-container_photo'>
          <img className="emas__articles-container_headImage" src={BPmonth} alt="BPmonth"></img>
          </div>
        <Published />
    </div>
</div>
  )
}
